import { IconButton } from '@mui/material'

export default IconButton
